import { Alert, Button, Col, Divider, Row } from 'antd';
import CartItem from './CartItem';
import { useCartStore } from '@/store';
import { Flex } from '@/components';
import { Link } from 'react-router-dom';
import { Routes } from '@/routes';

export default function CartListItems() {
  const programs = useCartStore(state => state.programs);
  const colClassnames = 'px-1 text-sm text-[#4d4d4d] font-bold text-center';

  if (programs.length === 0) {
    return (
      <Alert
        type="warning"
        className="mx-auto max-w-lg p-4"
        message={
          <Flex direction="column" justify="center">
            <span>سبد خرید شما خالی است. برای سفارش از رستوران آزاد استفاده کنید.</span>
            <Link className="mx-auto mt-4" to={Routes.Food}>
              <Button type="primary" size="small">رفتن به ماژول تغذیه</Button>
            </Link>
          </Flex>
        }
      />
    );
  }

  return (
    <>
      <Row className="flex p-1">
        <Col span={4} className={colClassnames}>تاریخ</Col>
        <Col span={10} className={colClassnames}>نام غذا</Col>
        <Col span={4} className={colClassnames}>تعداد</Col>
        <Col span={4} className={colClassnames}>مبلغ کل</Col>
        <Col span={2} className={colClassnames}></Col>
      </Row>
      <Divider />
      <div className="flex flex-col flex-fill">
        {programs.map(item => <CartItem key={item.food?.programId} food={item.food!} count={item.selectedCount} />)}
      </div>
    </>
  );
}
